import { ICustomerUpdateRequestsRepository } from 'modules/customer/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisCustomerUpdateRequestsRepository
  implements ICustomerUpdateRequestsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findByHash: ICustomerUpdateRequestsRepository['findByHash'] = async ({
    hash,
  }) => {
    const data = await this.httpProvider.get<{
      idCliente: number;
      nomeCompleto: string;
      email: string;
      foneCelular: string;
      dataHoraExpiracaoLink: string;
    }>(`/clientes/atualizacaoCadastro/${hash}`);

    return {
      customer: {
        id: data.idCliente,
        email: data.email,
        phone: data.foneCelular,
        fullName: data.nomeCompleto,
      },
      expiration: data.dataHoraExpiracaoLink,
    };
  };
}
